import TextInput from 'relements/build/esm/input/text';
import Chips from 'relements/build/esm/input/chips';
import Box from 'relements/build/esm/ui/box';
import Icon from 'relements/build/esm/ui/icon';
import Button from 'relements/build/esm/ui/button';
import styled from 'styled-components';
import Loader from 'relements/build/esm/ui/loader';
import Dropdown from 'relements/build/esm/input/dropdown';

export const StyledTextHSLContainer = styled(Box)`
  flex-direction: column;
  padding: 24px;
  background-color: #eee;
  border: 1px solid ${(props) => props.theme.colors.grey.pastel};
  border-radius: ${(props) => props.theme.radii.sm}px;
  margin: 16px 0px 16px 0px;
`;

export const IconWrapper = styled(Icon)({
  width: 100,
  height: 100,
  pointerEvents: 'none',
});
export const StyledLoader = styled(Loader)`
  position: fixed;
  top: 50%;
  left: 50%;
`;
export const StyledOverlayLoader = styled(Loader)`
  position: absolute;
  z-index: 111;
  background: rgba(242, 242, 242, 0.4);
  height: 100% !important;
  width: 100% !important;
  > svg {
    width: 32px;
    height: 32px;
  }
`;

export const MainWrapper = styled.div`
  height: 100%;
  overflow: auto;
`;

export const Wrapper = styled(Box)`
  flex-direction: column;
  padding: 24px;
  background-color: ${(props) => props.theme.colors.grey.pastel};
  border: 1px solid ${(props) => props.theme.colors.grey.pastel};
  border-radius: ${(props) => props.theme.radii.sm}px;
  margin: 16px 16px 100px 16px;
`;

export const AdditionalFeatures = styled(Box)`
  border: 1px solid ${(props) => props.theme.colors.grey.haptik};
  border-radius: ${(props) => props.theme.radii.sm}px;
  margin-top: 24px;
  cursor: pointer;
`;

export const StyledButton = styled(Button)`
  font-size: 14px;
  margin-right: -8px;
  width: 63px;
  height: 36px;
  border-radius: 4px;
  &:disabled {
    background: ${(props) => props.theme.colors.grey.haptik};
    color: ${(props) => props.theme.colors.grey.dark};
  }
`;

export const StyledChips = styled(Chips)`
  margin-top: 24px;
  > div {
    border-radius: 4px;
    border-color: ${(props) =>
      props.chiperror && props.theme.colors.red.haptik};
  }
  & input {
    min-height: 21px;
  }
`;

export const StyledTextInput = styled(TextInput)`
  margin-top: ${(props) => props.marginTop ?? '0px'};
`;

export const StyledIcon = styled(Icon)`
  width: 16px;
  height: 16px;
  transition: transform 0.2s ease;
  transform: ${(props) => props.active && 'rotate(180deg)'};
  margin-left: 12px;
  cursor: pointer;
`;

export const StyledDropdown = styled(Dropdown)`
  margin-top: 50px;
`;

export const UserDetailsContainer = styled(Box)`
  border: 1px solid ${(props) => props.theme.colors.grey.haptik};
  border-radius: ${(props) => props.theme.radii.sm}px;
  background: ${(props) => props.theme.colors.grey.soft};
  cursor: auto;
`;
